import React from "react";

type CompleteProps = {
  className?: string;
}

export const Complete = ({ className }: CompleteProps) => {
  return (
    <svg className={className} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#00703C"/>
      <path d="M28.23 11L26.8451 12.4615C23.0885 16.399 20.2204 19.6873 16.7337 23.4103L13.0201 20.1283L11.5248 18.8078L9 21.936L10.4953 23.2693L15.5939 27.782L16.9666 29L18.2412 27.6667C22.4652 23.2388 25.4726 19.7021 29.6151 15.3591L31 13.8976L28.23 11Z" fill="white"/>
    </svg>
  )
}
